import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';

import css from './index.styl?inline';

export default registerMPElement(
  `mp-alert`,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        closeable: `boolean`,
        'large-icon': `boolean`,
        'not-fullscreen': `boolean`,
        open: `boolean`,
        icon: `string`,
        'icon-color': `string`,
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,

        helpers: {
          modalChanged: (ev) => this.dispatchEvent(new CustomEvent(`change`, {detail: ev.detail})),
        },
      };
    }
  },
);
